/**
 * Display signed percentages with +/− prefix and positive/negative tone for table cells.
 */

/**
 * @param {unknown} value
 * @param {{ minFractionDigits?: number, maxFractionDigits?: number, showPlus?: boolean }} [options]
 * @returns {{ text: string, tone: 'empty' | 'neutral' | 'positive' | 'negative' }}
 */
export function formatSignedPercent(
  value,
  { minFractionDigits, maxFractionDigits = 2, showPlus = true } = {}
) {
  if (value == null || value === "") return { text: "—", tone: "empty" };
  const n = Number(value);
  if (!Number.isFinite(n)) return { text: "—", tone: "empty" };

  const formatted = n.toLocaleString(undefined, {
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  });
  const text = n > 0 && showPlus ? `+${formatted}%` : `${formatted}%`;
  const tone = n > 0 ? "positive" : n < 0 ? "negative" : "neutral";
  return { text, tone };
}

/** @param {'empty' | 'neutral' | 'positive' | 'negative'} tone */
export function signedPercentClassName(tone) {
  if (tone === "empty" || tone === "neutral") return "";
  return `signed-percent signed-percent--${tone}`;
}
